<template>
  <div class="donation-container">
    <!-- 纪录片收录按钮 -->
    <div class="submission-button">
      <button class="submission-trigger" @click="openSubmission">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"/>
          <path d="M8 12h8v2H8zm0 4h8v2H8zm0-8h5v2H8z"/>
        </svg>
        <span>纪录片收录</span>
      </button>
    </div>

    <!-- 捐赠按钮 -->
    <div class="donation-slider" style="display: none;">
      <div class="donation-trigger" @click="openDonation">
        <div class="donation-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1.81.45 1.61 1.67 1.61 1.16 0 1.6-.64 1.6-1.46 0-.84-.68-1.22-2.05-1.71-1.61-.58-3.11-1.39-3.11-3.27 0-1.62 1.05-2.76 2.81-3.12V5h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.63-1.63-1.63-1.01 0-1.46.54-1.46 1.34 0 .74.54 1.13 1.93 1.65 1.68.62 3.23 1.27 3.23 3.29 0 1.64-1.05 2.82-2.96 3.1z"/>
          </svg>
          <span class="donation-text">捐赠</span>
        </div>
      </div>
    </div>

    <!-- 意见反馈按钮 -->
    <div class="feedback-button">
      <button class="feedback-trigger" @click="openFeedback">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.2L4 17.2V4h16v12zm-7-1h2v-2h-2v2zm0-4h2v-4h-2v4z"/>
        </svg>
        <span>反馈</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
// 使用全局弹窗方法
const openDonation = () => {
  if ((window as any).globalModal?.openDonation) {
    (window as any).globalModal.openDonation()
  }
}

const openFeedback = () => {
  if ((window as any).globalModal?.openFeedback) {
    (window as any).globalModal.openFeedback()
  }
}

const openSubmission = () => {
  if ((window as any).globalModal?.openSubmission) {
    (window as any).globalModal.openSubmission()
  }
}
</script>

<style scoped>
.donation-container {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: var(--z-overlay);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 纪录片收录按钮 */
.submission-button {
  display: flex;
  justify-content: flex-end;
}

.submission-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Georgia', 'Times New Roman', serif;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.submission-trigger svg {
  width: 16px;
  height: 16px;
}

.submission-trigger:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

/* 捐赠按钮 */
.donation-slider {
  position: relative;
  display: flex;
  justify-content: flex-end;
}

.donation-trigger {
  cursor: pointer;
  transition: all 0.3s ease;
}

.donation-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--gradient-primary);
  color: var(--white);
  padding: 12px 20px;
  border-radius: 25px;
  box-shadow: 0 4px 15px rgba(139, 115, 85, 0.3);
  transition: all 0.3s ease;
  font-weight: 500;
  font-family: 'Georgia', 'Times New Roman', serif;
}

.donation-icon svg {
  width: 20px;
  height: 20px;
}

.donation-trigger:hover .donation-icon {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(139, 115, 85, 0.4);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .donation-modal-content {
    width: min(450px, 90vw);
  }
  
  .submission-modal-content {
    width: min(800px, 95vw);
  }
}

@media (max-width: 480px) {
  .donation-container {
    right: 10px;
    gap: 8px;
  }
  
  .donation-modal-content {
    width: min(400px, 95vw);
    margin: 10px;
    border-radius: 16px;
  }
  
  .donation-header {
    padding: 20px 20px 0 20px;
  }
  
  .donation-body {
    padding: 0 20px 20px 20px;
  }
  
  .qr-codes {
    gap: 16px;
  }
  
  .qr-code {
    width: 120px;
    height: 120px;
  }
  
  .qr-label {
    font-size: 13px;
  }
  
  .submission-trigger,
  .donation-icon {
    padding: 10px 16px;
    font-size: 13px;
  }
  
  .donation-title {
    font-size: 18px;
  }
  
  .donation-description {
    font-size: 14px;
  }
}

/* 意见反馈按钮 */
.feedback-button {
  display: flex;
  justify-content: flex-end;
}

.feedback-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Georgia', 'Times New Roman', serif;
  box-shadow: 0 4px 15px rgba(17, 153, 142, 0.3);
}

.feedback-trigger svg {
  width: 16px;
  height: 16px;
}

.feedback-trigger:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(17, 153, 142, 0.4);
}
</style>